import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import SpinnerComponent from '../../../components/SpinnerComponent';
import PdfAttachmentComponent from './PdfAttachmentComponent';
import ImageAttachmentComponent from './ImageAttachmentComponent';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '20px',
    marginBottom: '20px',
    minHeight: '296px',
  },
  rootEmpty: {
    minHeight: 'auto',
  },
  text: {
    margin: '5px 0px 10px 0px',
  },
  gridContainer: {
    paddingTop: '10px',
    width: '100%',
  },
  attachmentItem: {
    width: '100%',
    maxWidth: '100%',
  },
  emptyMessage: {
    padding: theme.spacing(2),
    fontStyle: 'italic',
    textAlign: 'center',
  },
}));

export default function AttachmentList(props) {
  const classes = useStyles();
  const hasAttachments = props.attachments.length > 0;
  const showEmptyMessage =
    !props.loading && !hasAttachments && Boolean(props.emptyMessage);

  return (
    <Container
      maxWidth="md"
      className={`${classes.root} ${showEmptyMessage ? classes.rootEmpty : ''}`}
    >
      {props.title && (
        <Typography variant="h6" className={classes.text}>
          {props.title}
        </Typography>
      )}
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.gridContainer}
      >
        {props.loading ? (
          <SpinnerComponent size={32} />
        ) : showEmptyMessage ? (
          <Typography
            className={classes.emptyMessage}
            color="textSecondary"
            variant="body2"
          >
            {props.emptyMessage}
          </Typography>
        ) : (
          props.attachments.map((item) => {
            const attachmentProps = {
              index: item.posizione,
              onMove: props.onMove,
              onRemoveAttachment: props.onRemoveAttachment,
              totalAttachments: props.attachments.length,
            };

            return (
              <Grid
                item
                xs={12}
                key={item.id}
                className={classes.attachmentItem}
              >
                {item.type !== 'PDF' ? (
                  <ImageAttachmentComponent
                    {...attachmentProps}
                    image={item}
                    onChangeField={props.onChangeField}
                    urlPath={props.urlPath}
                  />
                ) : (
                  <PdfAttachmentComponent
                    {...attachmentProps}
                    pdfAttachment={item}
                    onViewPdf={props.onViewPdf}
                  />
                )}
              </Grid>
            );
          })
        )}
      </Grid>
    </Container>
  );
}

AttachmentList.propTypes = {
  loading: PropTypes.bool,
  attachments: PropTypes.array.isRequired,
  onChangeField: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
  onRemoveAttachment: PropTypes.func.isRequired,
  onViewPdf: PropTypes.func,
  title: PropTypes.string,
  emptyMessage: PropTypes.string,
  urlPath: PropTypes.string.isRequired,
};
